import React from 'react';
import { bool, func, object, shape, string } from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { useMessages, useAppState, useConfig } from '@ynap/immutables-provider';
import { useDeliveryInfo } from '@ynap/delivery-hook';
import ReactMarkdown from 'markdown-to-jsx';

const bem = new BEMHelper('DeliveryAndReturnsSummary');

const deliveryAndReturnsSelector = (messages) => messages?.deliveryAndReturns;

export const DeliveryAndReturnsSummary = ({ className, onClick, isEip }) => {
    const config = useConfig();
    const { country } = useAppState();
    const deliveryAndReturns = useMessages(deliveryAndReturnsSelector);
    const enableDeliveryAndReturnCustomMessage = config?.head?.pdp?.enableDeliveryAndReturnCustomMessage;
    const { deliveryLink, returnsLink } = useDeliveryInfo();

    const Link = (props) => (
        <a className={bem('link')} href={props.href} target="_blank" rel="noopener noreferrer">
            {props.children}
        </a>
    );

    return (
        <div className={bem(null, null, className)} data-testid="DeliveryAndReturnsSummary" onClick={onClick}>
            <h2 className={bem('title')}>{deliveryAndReturns?.title?.()}</h2>
            <ReactMarkdown
                options={{
                    forceBlock: true,
                    overrides: {
                        a: Link,
                    },
                }}
                className={bem('description')}
            >
                {deliveryAndReturns?.description?.({
                    returnsLink,
                    deliveryLink,
                    country: enableDeliveryAndReturnCustomMessage && country?.toUpperCase(),
                    isEip,
                })}
            </ReactMarkdown>
        </div>
    );
};

DeliveryAndReturnsSummary.propTypes = {
    className: string.isRequired,
    messages: shape({
        deliveryAndReturns: shape({
            title: func.isRequired,
            description: func.isRequired,
        }),
    }),
    onClick: func,
    config: object,
    country: string,
    isEip: bool,
};
